export function calculateRecordingLength(startTime, endTime) {
  return endTime - startTime
}
